import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CalendarDaysIcon, BuildingOfficeIcon } from '@heroicons/react/16/solid';
import JobAdderLogo from '../images/jobAdder/jobAdderLogo.svg';
import { getAccountFromUrl, appendAccountToUrl } from '../utils/appointments/urlUtils';

export default function ApplicationDashboard() {
    const navigate = useNavigate();
    const location = useLocation();
    const [search, setSearch] = React.useState("");

    // Get account number from URL
    const acctNo = getAccountFromUrl(location.search);

    const apps = [
        {
            name: 'Appointments',
            description: 'Manage appointments and schedules within WhatsApp.',
            route: '/appointments',
            color: 'bg-emerald-500',
            icon: <CalendarDaysIcon className="w-8 h-8 text-white" />,
        },
        {
            name: 'Bookings',
            description: 'Hotel and resource booking system within WhatsApp.',
            route: '/hotelBooking',
            color: 'bg-pink-500',
            icon: <BuildingOfficeIcon className="w-8 h-8 text-white" />,
        }
    ];

    // Handle application selection with account number preservation
    const getAppRoute = (app) => {
        return acctNo ? appendAccountToUrl(app.route, acctNo) : app.route;
    };

    const filteredApps = apps.filter(app =>
        app.name.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col p-8">
            <div className="w-full flex flex-col items-center mb-8">
                <h1 className="text-4xl font-extrabold mb-6 mt-2">
                    <span className="bg-clip-text text-transparent bg-gradient-to-r from-black via-gray-500 to-emerald-400 bg-[length:200%_auto] animate-slow-wave">
                        Application Hub
                    </span>
                </h1>
                <input
                    type="text"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    placeholder="Search application..."
                    className="mb-2 px-4 py-2 border border-gray-300 rounded w-full max-w-md text-sm"
                />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full max-w-5xl mx-auto">
                {filteredApps.map(app => (
                    <a
                        key={app.name}
                        href={getAppRoute(app)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cursor-pointer rounded-xl shadow-lg p-5 flex flex-col items-center transition-transform hover:scale-105 text-black no-underline"
                    >
                        <div className="mb-4 relative w-14 h-14 flex items-center justify-center">
                            {/* Gradient background behind icon, color based on app */}
                            {app.name === 'Appointments' && (
                                <div className="absolute inset-0 bg-gradient-to-br from-emerald-400 via-teal-500 to-cyan-600 rounded-xl shadow-lg"></div>
                            )}
                            {app.name === 'Bookings' && (
                                <div className="absolute inset-0 bg-gradient-to-br from-purple-400 via-pink-500 to-red-500 rounded-xl shadow-lg"></div>
                            )}
                            <span className="relative z-10 flex items-center justify-center w-full h-full">{app.icon}</span>
                        </div>
                        <h2 className="text-lg font-extrabold mb-2">{app.name}</h2>
                        <p className="text-center text-sm opacity-90">{app.description}</p>
                    </a>
                ))}
            </div>
        </div>
    );
}
